// @flow
import styled, { css } from "styled-components";

import buildColor from "../../_static/ColorPalette";

const Container = styled.section`
  background-color: ${buildColor("white", "100")};
  flex: 1 0 0;
  display: flex;
  flex-direction: column;
  ${(props) =>
    props.isInline &&
    css`
      border: 1px solid ${buildColor("grey", "300")};
      border-radius: 2px;
      overflow: hidden;
    `};
`;

export default Container;
